import { type RecordSourceSelectorProxy, type RecordProxy } from 'relay-runtime';

const ADD_PHOTO_LIKE = 'ADD_PHOTO_LIKE';
const REMOVE_PHOTO_LIKE = 'REMOVE_PHOTO_LIKE';
type PhotoLikeAction = typeof ADD_PHOTO_LIKE | typeof REMOVE_PHOTO_LIKE;

const updateTotalLikes = (photoLikeRecord: RecordProxy, action: PhotoLikeAction): void => {
    let totalPhotoLikes = photoLikeRecord.getValue('totalPhotoLikes');
    if (typeof totalPhotoLikes === 'number') {
        totalPhotoLikes = action === 'ADD_PHOTO_LIKE' ? totalPhotoLikes + 1 : totalPhotoLikes - 1;
        photoLikeRecord?.setValue(totalPhotoLikes, 'totalPhotoLikes');
    }
};

type OptimisticUpdater = {
    store: RecordSourceSelectorProxy;
    optimisticResult: boolean;
    photoNodeId: string;
    userId: string;
};

export const optimisticPhotoLikeUpdater = ({
    store,
    optimisticResult,
    photoNodeId,
    userId,
}: OptimisticUpdater): void => {
    const photoRecord = store.get(photoNodeId);
    const photoLikeRecord = photoRecord?.getLinkedRecord('photoLike');
    if (photoLikeRecord) {
        photoLikeRecord.setValue(optimisticResult, 'photoLikeId', { userId });
        const action = optimisticResult ? ADD_PHOTO_LIKE : REMOVE_PHOTO_LIKE;
        updateTotalLikes(photoLikeRecord, action);
    }
};

type Updater = {
    store: RecordSourceSelectorProxy;
    photoNodeId: string;
    userId: string;
};

export const addPhotoLikeUpdater = ({ store, photoNodeId, userId }: Updater): void => {
    const photoRecord = store.get(photoNodeId);
    const photoLikeRecord = photoRecord?.getLinkedRecord('photoLike');
    const payload = store.getRootField('addPhotoLikeMutation');
    const photoLikeId = payload?.getValue('photoLikeId') || null;
    if (photoLikeRecord) {
        photoLikeRecord.setValue(photoLikeId, 'photoLikeId', { userId });
        updateTotalLikes(photoLikeRecord, ADD_PHOTO_LIKE);
    }
};

export const removePhotoLikeUpdater = ({ store, photoNodeId, userId }: Updater): void => {
    const photoRecord = store.get(photoNodeId);
    const photoLikeRecord = photoRecord?.getLinkedRecord('photoLike');
    const payload = store.getRootField('removePhotoLikeMutation');
    const isSuccessful = payload?.getValue('success');
    if (photoLikeRecord && isSuccessful) {
        photoLikeRecord.setValue(null, 'photoLikeId', { userId });
        updateTotalLikes(photoLikeRecord, REMOVE_PHOTO_LIKE);
    }
};
